<template>
    <div class="news-page" @scroll="bingsrcoll">
        <!-- 正文 -->
        <div class="hidden-sm-and-down">
            <div class="first-page" v-if="informationData.children.length!=0">
                <!-- <img src="../assets/mobile/new_web_banner.png" style="width:100%;"> -->
                <img v-if="informationData.children[0].requestType.indexOf('image')>-1" :src="informationData.children[0].requestPath" :alt="informationData.dictLabel" style="width:100%;">
            </div>
            <div class="scenemain col-md-90">
                <div>
                    <el-breadcrumb separator-class="el-icon-arrow-right">
                        <el-breadcrumb-item to="/news" v-if="isEn ==='0'" style="font-size:16px">新闻动态</el-breadcrumb-item>
                        <el-breadcrumb-item to="/news" v-if="isEn ==='1'" style="font-size:16px">News and Trends</el-breadcrumb-item>
                        <el-breadcrumb-item v-for="(item, index) in news_listRoute" :key="index">
                            <router-link :to="{ path: item.path }" style="font-size:16px">
                                {{ item.meta.title }}
                            </router-link>
                        </el-breadcrumb-item>
                    </el-breadcrumb>
                </div>

                <div>
                    <div class="list" @click="newsDetailClick(item)" v-for="(item, index) in news_list" :Key="index" style="cursor: pointer;">
                        <div style="width:300px;height:180px;margin-right: 39px;">
                            <img :src="item.picUrl" style="width:100%;height:100%;">
                        </div>
                        <div class="listRight">
                            <div class="newsHeadlines text-content">{{ item.title }}</div>
                            <div style="height:66%;">
                                <div
                                    style="display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 2;overflow: hidden;width: 100%;font-size: 14px;color: #2C2C2C">
                                    {{ item.remark }}
                                </div>

                            </div>
                            <div style="height:10%;font-size: 14px;color: #838383;">{{ item.publishTime }}</div>
                        </div>
                    </div>
                    <!--<pagination v-show="total > 0" :total="total" :page.sync="queryParams.pageNum"
                        :limit.sync="queryParams.pageSize" @pagination="getData" />-->

                </div>
            </div>

            <home-foot></home-foot>
        </div>
        <!-- 移动端 -->
        <div class="visible-sm-and-down">
            <!-- <div class="first-pages">
                <img src="../assets/mobile/news.png" style="width:100%">
            </div> -->
            <div
                style="font-size: 24px;color: #202020;letter-spacing: 0;text-align: left;line-height: 24px;padding: 23px 0px 16px 23px;">
                新闻列表
            </div>
            <div class="cu-card article" @click="newsDetailClick(item)" v-for="(item, index) in news_list" :Key="index">

                <div class="cu-item">

                    <div class="content">
                        <div style="width:60%;display: flex;flex-direction: column;justify-content: space-between;">
                            <div class="title">
                                <div class="text-cut">{{ item.title }}</div>
                            </div>
                            <div class="desc">
                                <div style="font-size: 14px;color: #838383;">{{ item.publishTime }}
                                </div>
                            </div>
                        </div>
                        <div style="width:40%" class="newsImg">
                            <img :src="item.picUrl" mode="aspectFill" />
                        </div>
                    </div>
                </div>
            </div>
            <home-foot></home-foot>
        </div>

    </div>
</template>



<script scope>
import HomeFoot from "@/components/HomeFoot";

export default {
    name: "newsList",
    data() {
        return {
            uuid: '',
            scroll_Value: 0,
            news_listRoute: [], //路由
            news_list: [],  //列表数据
            informationData:{},
            // 总条数
            total: 0,
            // 查询参数
            queryParams: {
                pageNum: 1,
                pageSize: 10,
            },
            isEn:'0',
        };
    },

    components: {
        HomeFoot
    },
    watch: {
        $route(to, from) {
            //监听路由变化
            this.getBreadcrumb();
        },
    },

    created() {
        this.getBreadcrumb();
        this._isMobile()
        this.$picData.map((item) => {
            if (item.dictCode == 150) {
                this.informationData = item
                console.log(this.informationData,'this.informationData ')
            }

        })
        this.isEn = ('1' ==sessionStorage.getItem("isEn")? sessionStorage.getItem("isEn") : '0')
    },

    mounted() {
        $('.news-page').animate({ scrollTop: 0 }, 600);

       /* if (this._isMobile()) {
            this.getList()
        } else {
            this.getData()
        }*/
        this.getList()

    },

    methods: {
        //App.vue
        _isMobile() {
            let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
            return flag;
        },
        newsDetailClick(e) {
            if (this.isEn == '1'){
              this.$router.push({ name: "newsDetail_en", query: { uuid: e.uuid,type:'2'} })
            } else {
              this.$router.push({ name: "newsDetail", query: { uuid: e.uuid,type:'2'} })
            }
        },
     /*   getData() {
            this.news_list = [];
            axios.get(`${window.$server_config.VUE_APP_WEBSITE_API}outer/news/list?isEn=`+this.isEn, { params: this.queryParams }
            ).then((response) => {
                let res = response.data
                if (res.code == 200) {
                    this.total = res.total
                    this.news_list = res.rows
                } else {
                }
            }).catch(res => {

            })
        },*/
        getList() {
            this.news_list = [];
            axios.get(`${window.$server_config.VUE_APP_WEBSITE_API}outer/news/list?isEn=`+this.isEn
            ).then((response) => {
                var res = response.data
                if (res.code == 200) {
                    this.total = res.total
                    this.news_list = res.rows
                } else {
                }
            }).catch(res => {

            })
        },
        bingsrcoll(e) {
            this.scroll_Value = e.srcElement.scrollTop;
        },
        getBreadcrumb() {
            this.news_listRoute = this.$route.matched.filter(
                (item) => item.meta && item.meta.title
            );
        },

    }

};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.news-page {
    padding-top: 65px;
    height: 100%;
}

.scenemain {
    margin: 0 auto;
    margin-top: 50px;
    margin-bottom: 56px;
}

@media only screen and (max-width:991px) {
    .news-page {
        padding-top: 50px;
    }
}

.list {
    border-bottom: 1px solid #E3E3E3;
    display: flex;
    padding: 40px 0px;
    width: 100%;
    height: 260px;
}

.list:last-child {
    border-bottom: none;

}

.newsHeadlines {
    font-family: PingFangSC-Medium;
    font-size: 20px;
    color: #202020;
    letter-spacing: 0;
    text-align: left;
    line-height: 20px;
    padding-bottom: 5px;
    letter-spacing: 1px
}

.listRight {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: calc(100% - 339px);
}

.cu-card {
    display: block;
    overflow: hidden;
}

.cu-card.article {
    display: block;

}

.cu-card>.cu-item {
    display: block;
    background-color: var(--white);
    overflow: hidden;
    /* margin: 0px 12px 12px 12px; */
    margin: 0px 23px 23px 23px;
    border-bottom: 1px #E3E3E3 solid;
    padding-bottom: 23px;

}

.cu-card.article>.cu-item .title {
    font-size: 16px;
    font-weight: 900;
    color: var(--black);
}

.text-cut {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    font-size: 16px;
    color: #2C2C2C;
    padding-right:28px
}

.cu-card.article>.cu-item .content {
    display: flex;
    width: 100%;
    height: 95px;
    justify-content: space-between;
}

.cu-card.article>.cu-item .content .newsImg>img {
    width: 100%;
    height: 100%;
    max-width: 100%;
    display: inline-block;
    position: relative;
    z-index: 0;
}
.newsImg {
    height: 100%;
    max-width: 150px;
}

.text-content {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
}

.first-pages {
    width: 100%;
}

.first-pages img {
    object-fit: cover;
}
</style>



// WEBPACK FOOTER //
// src/views/newsList.vue